import React from "react";
import cn from "classnames";
import styles from "./tooltip.module.scss";

export type ToolTipPositionType =
  | "top"
  | "right"
  | "bottom"
  | "left"
  | "top-left"
  | "top-right"
  | "bottom-left"
  | "bottom-right"
  | "top-left-corner"
  | "top-right-corner"
  | "bottom-left-corner"
  | "bottom-right-corner";

interface ToolTipProps {
  content: string;
  children: React.ReactNode;
  position?: ToolTipPositionType;
  widthHundertPercent?: boolean;
}

export const ToolTip = ({
  content,
  children,
  position = "top",
  widthHundertPercent = false,
}: ToolTipProps) => {
  return (
    <div
      className={cn(styles.tooltip, {
        [styles[`tooltip__tooltiptext--width-hundert-percent`]]:
          widthHundertPercent,
      })}
    >
      {children}
      <span
        className={cn(
          styles.tooltip__tooltiptext,
          styles[`tooltip__tooltiptext--${position}`],
        )}
      >
        {content}
      </span>
    </div>
  );
};
